<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isServiceManager()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
				<h2>Jobs with pending updates | Service Manager</h2>
			  <br>
			  <p>Please make sure to close/complete old jobs to keep this report accurate.</p>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<div class="col-lg-12">
	<div class="card card-outline card-danger collapsed-card">
		<div class="card-header">
			<div class="card-title">Data Filters</div>
			<div class="card-tools">
      <!-- Collapse Button -->
      <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i></button>
    </div>
		</div>
		<div class="card-body">
			<div class="col-md-12">
			<div class="row">
				
      		<div class="col-sm-4">
				  <div class="form-group">
					  <span class="right badge badge-secondary 	">Results to display per page::</span>
      			<input type="number" class="form-control" min="5" value="10" v-model="results" placeholder=" Enter No. of results" @input="getJobs('/api/getJobsPending')">
      		</div>
			  </div>
      		<div class="col-sm-4">
				  <div class="form-group">
					  <span class="right badge badge-secondary 	">Select From Date:</span>
      			<input type="date" class="form-control" v-model="from_date" placeholder="Select date">
      		</div>
			  </div>
      		<div class="col-sm-4">
				  <div class="form-group">
					  <span class="right badge badge-secondary 	">Select To Date:</span>
      			<input type="date" class="form-control" v-model="to_date" placeholder="Select date">
      		</div>
			  </div>
      		<div class="col-sm-4">
				  <div class="form-group">
					  <span class="right badge badge-secondary 	">Select TAT Condition:</span>
      			<select class="form-control" v-model="tat">
      				<option value="1">Over TAT</option>
      				<option value="0">Under TAT</option>
      			</select>
      		</div>
			  </div>
      		<div class="col-sm-4">
				  <div class="form-group">
					  <span class="right badge badge-secondary 	">Select Job Category:</span>
      			<select class="form-control" placeholder="Job Category" v-model="under_warranty">
							<option v-for="c in job_categories" :value="c.name">{{c.name}}</option>
						</select>
					</div>
			  </div>
      		<div class="col-sm-4">
				  <div class="form-group">
					  <span class="right badge badge-secondary 	">Select by Executive:</span>
      			<v-select v-model="tech" type="text" label="name" :options="techs" :reduce="techs => techs.id" placeholder="Select Executive" :value="techs => techs.id"></v-select>
					</div>  
			</div>   		
    
      </div>
	  <br>
	  <div class="row">
		<div class="col-sm-4">
			  <div class="form-group">
      			<button class="btn btn-danger" style="width:100% !important;" @click="reset"><i class="fa fa-times"></i> Reset</button>
      		</div>
		  </div>

      	<div class="col-sm-4">
      		<div class="form-group">
      			<button class="btn btn-danger" style="width:100% !important;" @click="getJobs('/api/getJobsPending')"><i class="fa fa-search"></i> Search</button>
      		</div>
		  </div>
		  
      		<div class="col-sm-4">
      		<div class="form-group">
      			<button class="btn btn-secondary" style="width:100% !important;" @click="excel"><i class="fa fa-print"></i> Generate Excel</button>
      		</div>
      	</div>
	  </div>
      </div>
		</div>
	</div>
</div>
<!-- main row for all icons  -->
<div class="col-lg-12">
	<div class="card card-danger card-outline">
		<div class="card-header">
			Pending Update - Report
		</div>
		<div class="card-body overflow-auto">
      <img v-if="jobs==''" src=""/>
			<datatable style="margin-top:1%;" :columns="columns" v-else>
				<tbody>
					<tr v-for="job in jobs" :key="job.id">
						<td>{{job.created}}</td>
						<td>{{job.job_no}}</td>
						<td>{{job.attending_name}}</td>
						<td>{{job.last_update}}</td>
						<td>
							<button class="btn btn-primary" @click="jobDets(job)"><i class="fa fa-eye"></i> View</button>
						</td>
					</tr>
				</tbody>
			</datatable>
			<!-- content here -->

    </div>
    <div class="card-footer">
    	<pagination :pagination="pagination"
       	@prev="getJobs(pagination.prevPageUrl)"
        @next="getJobs(pagination.nextPageUrl)"
      ></pagination>
		</div>
	</div>
</div>
<!-- row end -->
    </section>
    <!-- /.content -->

    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isServiceManager()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		import Datatable from '../../datatable.vue';
    import Pagination from '../../pagination.vue';
    import { saveAs } from 'file-saver';
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        components: {datatable:Datatable, pagination:Pagination},
        
        created(){
        	this.getJobs();
        	this.getTechs();
        	this.getJobCategories();
        },
        
        data(){
        	let columns = [
        		{width:'20%', label:'Update Pending On', name:'created'},
      			{width:'20%', label:'Job No.', name:'job_no'},
      			{width:'20%', label:'Attending Name', name:'attending_name'},
      			{width:'20%', label:'Last Update', name:'last_update'},
      			{width:'20%', label:'Manage', name:'ops'},
      		];
      		
      		return {
      			columns: columns,
      			pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		jobs: [],
         		results: '',
         		date: '',
         		tech: '',
         		techs: [],
         		from_date: '',
         		to_date: '',
         		tat: '',
         		under_warranty: '',
         		job_categories: []
         		//branch: '',
         		//city: ''
      		}
        },
        
        methods: {
        	configPagination(data){
      		this.pagination.lastPage=data.lastPage;
         	this.pagination.currentPage=data.current_page;
    	  	this.pagination.total=data.total;
        	this.pagination.lastPageUrl=data.last_page_url;
       		this.pagination.nextPageUrl=data.next_page_url;
       		this.pagination.prevPageUrl=data.prev_page_url;
     		 	this.pagination.from=data.from;
        	this.pagination.to=data.to;
    		},
    		
    		getJobCategories(){
        		axios.post("/api/getAllJobCategories")
        		.then(response => {
        			this.job_categories = response.data;
        		})
        	},
    		
        	getJobs(url="/api/getJobsPending"){
        		axios.post(url, {results: this.results, from_date: this.from_date, to_date: this.to_date, tech: this.tech, tat: this.tat, job_category: this.under_warranty})
        		.then(response => {
        			this.jobs = response.data.data.data;
        			this.configPagination(response.data.data);
        		})
        	},
        	
        	excel(){
        		axios({
        		url: "/api/getJobsPendingExcel", 
        		data: {tech: this.tech, from_date: this.from_date, to_date: this.to_date, tat: this.tat, job_category: this.under_warranty},
        		method: 'post',
        		responseType: 'blob'
        		})
        		.then(response => {
        			toast.fire({
        				icon: 'success',
        				title: 'Report Generated'
        			})
        			var blob = new Blob ([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        			if(this.from_date != '' && this.to_date != '')
        				saveAs(response.data, this.from_date+'-'+this.to_date+"_pending.xlsx");
        			else
        				saveAs(response.data, "pending.xlsx");
        		})
        	},
        	
        	getTechs(){
        		axios.post("/api/getTechs")
        		.then(response => {
        			this.techs = response.data;
        		})
        	},
        	
        	jobDets(job){
        		this.$router.push("/service-manager/job-profile/"+job.job_id);
        	},
        	/*excel(){
        		axios({
        		url: "/api/branchesExcel", 
        		data: {city: this.city},
        		method: 'post',
        		responseType: 'blob'
        		})
        		.then(response => {
        			toast.fire({
        				icon: 'success',
        				title: 'Report Generated'
        			})
        			var blob = new Blob ([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        			if(this.city != '')
        				saveAs(response.data, this.city+"_branches.xlsx");
        			else
        				saveAs(response.data, "branches.xlsx");
        		})
        	},
        	
        	sync(){
        		toast.fire({
        			icon: 'warning',
        			title: 'Wait For Syncing to be Over'
        		})
        		axios.post("/api/syncBranches")
        		.then(response => {
        			toast.fire({
        				title: response.data+" Items Synced",
        				type: "success"
        			});
        			this.getBranches();htm
        		})
        		.catch(() => {
        			toast.fire({
        				title: "Syncing Failed! Try Again.",
        				type: "error"
        			});
        		})
        	},*/
        	
        	reset(){
        		this.from_date = '';
        		this.to_date = '';
        		this.tech = '';
        		this.tat = '';
        		this.under_warranty = '';
        		this.getJobs();
        	}
        }
    }
</script>
